/* ==========================================================================
   Fishs Eddy — B2B wholesale collection
   Pairs with sections/main-b2b-collection.liquid and sections/b2b-quick-view.liquid.
   Progressive enhancement only: without this file, quantity fields still
   work, Add posts to the cart page, filters and sort are plain links, and
   Quick view stays hidden.
   ========================================================================== */
(() => {
  if (window.feB2bCollection) return;
  window.feB2bCollection = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ADDED_MS = 2200;

  /* ---------- Quantity steppers: move in case-pack steps ---------- */
  const snap = (input, value) => {
    const step = Number(input.step) || 1;
    const min = Number(input.min) || step;
    const max = input.max ? Number(input.max) : Infinity;
    let v = Number.isFinite(value) ? value : min;
    // Round to the nearest valid quantity: min, min + step, min + 2 x step ...
    v = min + Math.round((v - min) / step) * step;
    return Math.min(Math.max(v, min), max);
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-fe-qty-step]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const dir = Number(btn.dataset.feQtyStep);
    const step = Number(input.step) || 1;
    input.value = snap(input, (Number(input.value) || 0) + dir * step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.fe-b2b-qty__input')) return;
    input.value = snap(input, Number(input.value));
  });

  /* ---------- Add to cart in place ---------- */
  const setLabel = (form, text) => {
    const label = form.querySelector('[data-fe-add-label]');
    if (label) label.textContent = text;
  };

  const updateCartBubble = (sections) => {
    if (!sections || !sections['cart-icon-bubble']) return;
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    const fresh = doc.querySelector('.shopify-section') || doc.body;
    bubble.innerHTML = fresh.innerHTML;
  };

  /* ---------- Theme cart drawer ----------
     The theme renders either sections/cart-drawer or sections/v2-cart-drawer (A/B test).
     After each add we refresh its contents quietly (no auto-open), so "View cart" can open
     it already up to date. If there is no drawer, "View cart" goes to the cart page. */
  const cartDrawer = () => {
    const el = document.querySelector('cart-drawer');
    return el && typeof el.open === 'function' ? el : null;
  };
  const drawerSectionId = () => {
    const el = document.querySelector('cart-drawer');
    if (!el) return null;
    return el.classList.contains('m-main-cart-drawer-v2') ? 'v2-cart-drawer' : 'cart-drawer';
  };
  let drawerFresh = false;

  const refreshDrawer = (sections) => {
    const drawer = cartDrawer();
    const id = drawerSectionId();
    if (!drawer || !id || !sections || !sections[id]) return false;
    const doc = new DOMParser().parseFromString(sections[id], 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    const current = document.getElementById('CartDrawer');
    if (!fresh || !current) return false;
    current.innerHTML = fresh.innerHTML;
    drawer.classList.remove('is-empty');
    const inner = current.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    const overlay = current.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', () => drawer.close());
    if (typeof drawer.updateShippingProgress === 'function') drawer.updateShippingProgress();
    return true;
  };

  const clearProductStatus = (variantId) => {
    document.querySelectorAll(`[data-fe-buy][data-variant-id="${variantId}"]`).forEach((form) => {
      const status = form.querySelector('[data-fe-status]');
      if (!status) return;
      status.textContent = '';
      status.classList.remove('is-error');
      status.hidden = true;
    });
  };

  const updateInCart = (variantId, quantity) => {
    document.querySelectorAll(`[data-fe-incart="${variantId}"]`).forEach((el) => {
      const qty = el.querySelector('[data-fe-incart-qty]');
      if (qty) qty.textContent = quantity;
      el.hidden = quantity < 1;
    });
  };

  const syncCartUpdateInCartQty = (event) => {
    const variantId = Number(event && (event.variantId ?? event.productVariantId));
    if (!variantId) return;

    const cartItems = event && event.cartData && Array.isArray(event.cartData.items) ? event.cartData.items : [];
    const cartItem = cartItems.find((item) => Number(item.variant_id) === variantId || Number(item.id) === variantId);
    const nextQty = cartItem ? Number(cartItem.quantity) : 0;
    updateInCart(variantId, nextQty);
    clearProductStatus(variantId);
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartUpdateInCartQty);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('[data-fe-buy]')) return;
    event.preventDefault();

    const button = form.querySelector('[data-fe-add]');
    const status = form.querySelector('[data-fe-status]');
    const input = form.querySelector('input[name="quantity"]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    const variantId = Number(form.dataset.variantId);
    const quantity = snap(input, Number(input.value));
    input.value = quantity;
    const defaultLabel = button.dataset.feDefaultLabel || form.querySelector('[data-fe-add-label]').textContent;
    button.dataset.feDefaultLabel = defaultLabel;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-busy');
    setLabel(form, 'Adding…');
    status.textContent = '';
    status.classList.remove('is-error');
    status.hidden = true;

    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
          sections: ['cart-icon-bubble', drawerSectionId()].filter(Boolean).join(','),
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');

      const line = (data.items || []).find((item) => item.variant_id === variantId) || (data.items || [])[0];
      const inCart = line ? line.quantity : quantity;
      updateCartBubble(data.sections);
      drawerFresh = refreshDrawer(data.sections) || drawerFresh;
      updateInCart(variantId, inCart);

      button.classList.remove('is-busy');
      button.classList.add('is-added');
      setLabel(form, '✓ Added');
      status.innerHTML = '';
      status.hidden = false;
      status.append(`${quantity} added · ${inCart} in cart · `);
      const link = document.createElement('a');
      link.href = `${root}cart`;
      link.textContent = 'View cart';
      if (drawerFresh && cartDrawer()) {
        link.setAttribute('data-fe-open-cart', '');
        link.setAttribute('aria-haspopup', 'dialog');
      }
      status.append(link);
      document.dispatchEvent(new CustomEvent('fe:b2b:added', { detail: { variantId, quantity, inCart } }));

      window.setTimeout(() => {
        button.classList.remove('is-added');
        setLabel(form, defaultLabel);
      }, ADDED_MS);
    } catch (err) {
      button.classList.remove('is-busy');
      setLabel(form, defaultLabel);
      status.classList.add('is-error');
      status.hidden = false;
      status.textContent = `Couldn't add: ${err.message}`;
    } finally {
      button.removeAttribute('aria-disabled');
    }
  });

  /* ---------- Filter and sort dropdowns: one open at a time, Esc closes ---------- */
  const closeDropdowns = (except) => {
    document.querySelectorAll('[data-fe-dropdown][open]').forEach((d) => {
      if (d !== except) d.removeAttribute('open');
    });
  };
  document.addEventListener(
    'toggle',
    (event) => {
      const d = event.target;
      if (d.matches && d.matches('[data-fe-dropdown]') && d.open) closeDropdowns(d);
    },
    true,
  );
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-fe-dropdown]')) closeDropdowns();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = event.target.closest && event.target.closest('[data-fe-dropdown][open]');
    if (open) {
      open.removeAttribute('open');
      open.querySelector('summary').focus();
    }
  });

  /* ---------- Quick view ---------- */
  const dialog = () => document.querySelector('[data-fe-qv]');
  let lastTrigger = null;

  const revealQuickButtons = () => {
    if (!dialog() || typeof HTMLDialogElement !== 'function') return;
    document.querySelectorAll('[data-fe-quick][hidden]').forEach((b) => {
      b.hidden = false;
    });
  };
  revealQuickButtons();
  document.addEventListener('DOMContentLoaded', revealQuickButtons);
  document.addEventListener('shopify:section:load', revealQuickButtons);

  const initGallery = (scope) => {
    const gallery = scope.querySelector('[data-fe-gallery]');
    if (!gallery) return;
    const slides = [...gallery.querySelectorAll('[data-fe-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-fe-thumb]')];
    const counter = gallery.querySelector('[data-fe-counter]');
    const stage = gallery.querySelector('[data-fe-stage]');
    const zoom = gallery.querySelector('[data-fe-zoom]');
    let index = 0;

    const setZoom = (on) => {
      if (!zoom) return;
      stage.classList.toggle('is-zoomed', on);
      zoom.setAttribute('aria-pressed', String(on));
      zoom.querySelector('[data-fe-zoom-label]').textContent = on ? 'Zoom out' : 'Zoom in';
      if (on) {
        stage.setAttribute('tabindex', '0');
        stage.setAttribute('aria-label', 'Zoomed image. Use arrow keys or scroll to move around.');
        stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2;
        stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2;
      } else {
        stage.removeAttribute('tabindex');
        stage.removeAttribute('aria-label');
      }
    };

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => {
        s.hidden = n !== index;
      });
      thumbs.forEach((t, n) => {
        if (n === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(index + 1);
      setZoom(false);
    };

    gallery.addEventListener('click', (event) => {
      if (event.target.closest('[data-fe-prev]')) show(index - 1);
      else if (event.target.closest('[data-fe-next]')) show(index + 1);
      else if (event.target.closest('[data-fe-thumb]'))
        show(Number(event.target.closest('[data-fe-thumb]').dataset.feThumb));
      else if (event.target.closest('[data-fe-zoom]')) setZoom(!stage.classList.contains('is-zoomed'));
    });
  };

  const openQuickView = async (trigger) => {
    const dlg = dialog();
    if (!dlg || typeof dlg.showModal !== 'function') {
      window.location.href = trigger.dataset.feQuick;
      return;
    }
    const body = dlg.querySelector('[data-fe-qv-body]');
    lastTrigger = trigger;
    trigger.setAttribute('aria-busy', 'true');
    try {
      const url = trigger.dataset.feQuick;
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=b2b-quick-view`);
      if (!res.ok) throw new Error(res.statusText);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-fe-qv-content]');
      if (!content) throw new Error('No content');
      body.replaceChildren(content);
      initGallery(body);
      dlg.showModal();
      const heading = body.querySelector('#FeB2bQvTitle');
      if (heading) heading.focus();
    } catch (err) {
      window.location.href = trigger.dataset.feQuick;
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fe-quick]');
    if (trigger) {
      event.preventDefault();
      openQuickView(trigger);
      return;
    }
    const dlg = dialog();
    if (!dlg || !dlg.open) return;
    // Close button, or a click on the dimmed backdrop (outside the panel)
    if (event.target.closest('[data-fe-qv-close]') || event.target === dlg) dlg.close();
  });

  document.addEventListener(
    'close',
    (event) => {
      if (!event.target.matches || !event.target.matches('[data-fe-qv]')) return;
      event.target.querySelector('[data-fe-qv-body]').replaceChildren();
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    },
    true,
  );

  /* ---------- "View cart" opens the theme's cart drawer ---------- */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-fe-open-cart]');
    if (!link) return;
    const drawer = cartDrawer();
    if (!drawer) return; // no drawer: follow the link to the cart page
    event.preventDefault();

    const dlg = link.closest('dialog');
    if (dlg && dlg.open) {
      // Added from Quick view: close it first (a modal dialog sits above the drawer),
      // and send focus back to the card's Quick view button when the drawer closes.
      const returnTo = lastTrigger;
      dlg.close();
      window.setTimeout(() => drawer.open(returnTo && document.contains(returnTo) ? returnTo : undefined), 0);
    } else {
      drawer.open(link);
    }
  });

  /* ---------- Back to top ----------
     Floating pill at the bottom center (corners are taken by site widgets). Shows after
     scrolling down 1.5 screens, hides near the top and while the end-of-grid link is in view. */
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-fe-totop]');
    if (!link) return;
    event.preventDefault();
    const target = document.getElementById('MainContent') || document.body;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
  });

  const initBackToTop = () => {
    const pill = document.querySelector('[data-fe-totop-float]');
    if (!pill || pill.dataset.feReady) return;
    pill.dataset.feReady = 'true';
    pill.hidden = false; // shown only with JavaScript; CSS keeps it invisible until needed

    const endLink = document.querySelector('[data-fe-totop-end]');
    let endInView = false;
    if (endLink && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        endInView = entries.some((e) => e.isIntersecting);
        update();
      }).observe(endLink);
    }

    let ticking = false;
    function update() {
      ticking = false;
      const show = window.scrollY > window.innerHeight * 1.5 && !endInView;
      pill.classList.toggle('is-visible', show);
    }
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true },
    );
    update();
  };
  initBackToTop();
  document.addEventListener('DOMContentLoaded', initBackToTop);
  document.addEventListener('shopify:section:load', initBackToTop);
})();
